import { ModalContainer } from 'src/components/modals/ModalContainer/ModalContainer';
import Flex from 'src/styles/layouts/Flex';
import { EMediaQuery } from 'src/styles/theme/utils/enums';
import { mqV } from 'src/styles/theme/utils/functions';
import styled from 'styled-components';

export const FlexEx = styled(Flex)`
	${mqV('800px', 'height: 600px', 'min')}
`;

export const ModalContainerEx = styled(ModalContainer)`
	${mqV('800px', 'height: 80vh', 'max')}
	${mqV(EMediaQuery.xl, 'width: 530px;')}
	${mqV(EMediaQuery.md, 'max-width: 530px;', 'min')}
`;
